import { Link } from 'react-router-dom';

export default function DealerProgram() {
  const benefits = [
    'Better margins on bulk orders',
    'Priority stock allocation',
    'Dedicated account support',
  ];

  return (
    <section className="py-10 lg:py-16 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Universal Design - Same for All Devices */}
        <div className="space-y-6">
          {/* Hero Card - Premium B2B Design */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-slate-900 to-slate-800">
            {/* Content Grid */}
            <div className="grid lg:grid-cols-2 gap-8 items-center min-h-[320px] md:min-h-[400px] lg:min-h-[480px]">
              {/* Left Side - Text Content */}
              <div className="relative z-10 p-8 md:p-12 lg:p-16 space-y-6">
                {/* Top Badge */}
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-600 rounded-full">
                  <span className="text-xs md:text-sm font-semibold text-white">
                    Partnership Program
                  </span>
                </div>

                {/* Main Heading */}
                <div className="space-y-3">
                  <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight">
                    Become a GI2 Dealer
                  </h2>
                  <p className="text-lg md:text-xl lg:text-2xl text-gray-300 font-medium">
                    Join 500+ retailers growing with us
                  </p>
                </div>

                {/* CTA Button */}
                <div className="pt-4">
                  <Link
                    to="/become-a-dealer"
                    className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-teal-600 hover:bg-teal-500 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 group whitespace-nowrap cursor-pointer text-base md:text-lg"
                  >
                    Apply for Dealership
                    <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform w-5 h-5 flex items-center justify-center"></i>
                  </Link>
                </div>
              </div>

              {/* Right Side - Product Visuals */}
              <div className="hidden lg:flex relative h-full items-center justify-center p-8">
                <div className="relative w-full max-w-xl">
                  {/* Product Image with removed background */}
                  <img
                    src="https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/56821baf2b07e085c49d93d9a05074d6.png"
                    alt="GI2 Products"
                    className="w-full h-auto object-contain drop-shadow-2xl"
                    style={{
                      filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3))'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Benefits Grid - Compact Cards */}
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {/* Benefit 1 */}
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-4 md:p-6 border border-teal-200 shadow-sm">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-teal-600 rounded-lg mb-3">
                <i className="ri-percent-line text-xl md:text-2xl text-white w-5 h-5 md:w-6 md:h-6 flex items-center justify-center"></i>
              </div>
              <p className="text-sm md:text-base font-semibold text-teal-900 leading-snug">
                Better Margins on Bulk Orders
              </p>
            </div>

            {/* Benefit 2 */}
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-4 md:p-6 border border-orange-200 shadow-sm">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-orange-500 rounded-lg mb-3">
                <i className="ri-stack-line text-xl md:text-2xl text-white w-5 h-5 md:w-6 md:h-6 flex items-center justify-center"></i>
              </div>
              <p className="text-sm md:text-base font-semibold text-orange-900 leading-snug">
                Priority Stock Allocation
              </p>
            </div>

            {/* Benefit 3 */}
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-4 md:p-6 border border-purple-200 shadow-sm col-span-2 lg:col-span-1">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-purple-600 rounded-lg flex-shrink-0">
                  <i className="ri-customer-service-2-line text-xl md:text-2xl text-white w-5 h-5 md:w-6 md:h-6 flex items-center justify-center"></i>
                </div>
                <p className="text-sm md:text-base font-semibold text-purple-900 leading-snug">
                  Dedicated Account Support
                </p>
              </div>
            </div>
          </div>

          {/* Stats Row */}
          <div className="grid grid-cols-3 gap-3 md:gap-4">
            <div className="bg-white rounded-xl p-4 md:p-6 shadow-md border border-gray-100 text-center">
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-teal-700 mb-1">500+</div>
              <p className="text-xs md:text-sm text-gray-600 font-medium">Active Dealers</p>
            </div>
            <div className="bg-white rounded-xl p-4 md:p-6 shadow-md border border-gray-100 text-center">
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-orange-600 mb-1">24/7</div>
              <p className="text-xs md:text-sm text-gray-600 font-medium">Support</p>
            </div>
            <div className="bg-white rounded-xl p-4 md:p-6 shadow-md border border-gray-100 text-center">
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-purple-600 mb-1">Fast</div>
              <p className="text-xs md:text-sm text-gray-600 font-medium">Delivery</p>
            </div>
          </div>

          {/* CTA Button - Mobile Only */}
          <Link
            to="/become-a-dealer"
            className="flex lg:hidden items-center justify-center gap-2 w-full px-6 py-4 bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 group whitespace-nowrap cursor-pointer"
          >
            Apply Now
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
